<template>
  <div class="mb-main">
    <header>
      <img @click="clickLogo" class="logo" :src="require('@/assets/mobile/logo.png')"/>
      <div class="aside" :class="showMenu ? 'close' : 'menu'" @click="toggleMenu">
      </div>
    </header>
    <nav class="nav" v-if="showMenu">
      <ul>
        <li @click="() => toggleRoute(item)" v-for="item in menuList" :name="item.route" :key="item.route" :class="{active: item.route === activeRoute}">
          <a :name="item.route" >{{item.label}}</a>
        </li>
      </ul>
    </nav>
    <div class="mb-main-container" ref="container">
      <router-view class="routes"></router-view>
      <footer>
        <section class="one">
          <p class="name">国恒智慧能源服务有限公司</p>
          <p class="addr">深广东省深圳市南山区南海大道和登良路交汇处南海大道2168号恒大天璟B区24楼</p>
        </section>
        <section class="two">
          <p>服务热线：400-600-2888</p>
          <p>服务时间：周一至周五8:30-17:30</p>
        </section>
        <p class="ip">版权所有 © 国恒智慧能源服务有限公司</p>
        <p>
          <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备19105313号-1</a>
        </p>
        <p>
          <img style="width:20px; margin-right:10px;vertical-align: middle;" :src="require('../../assets/icp.png')" alt="">
          <a style="vertical-align: sub;" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030502009597" target="_blank">
            粤公网安备 44030502009597号
          </a>
        </p>
      </footer>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Main',
  data () {
    return {
      showMenu: false,
      activeRoute: 'mhome'
    }
  },
  computed: {
    menuList () {
      return [{ route: 'mhome', label: '首页' },
        { route: 'mproduct', label: '产品' },
        { route: 'msolution', label: '解决方案' },
        { route: 'mdownload', label: '下载' },
        { route: 'maboutus', label: '关于我们' }
      ]
    }
  },
  mounted () {
    this.activeRoute = this.setActiveRoute(this.$route.name)
  },
  watch: {
    '$route.name' (newVal) {
      this.$refs.container.scrollTop = 0
      this.activeRoute = this.setActiveRoute(newVal)
    }
  },
  methods: {
    setActiveRoute (item) {
      const map = { mhome: 'mhome', mguide: 'maboutus', mServiceSupport: 'maboutus', mproduct: 'mproduct', mProductBox: 'mproduct', mProductPile: 'mproduct', mProductPile1: 'mproduct', msolution: 'msolution', mdownload: 'mdownload', maboutus: 'maboutus' }
      return map[item]
    },
    toggleRoute (item) {
      if (!item.children) {
        this.$router.push({ name: item.route })
        this.toggleMenu()
      }
    },
    fixedBody () {
      const scrollTop = document.body.scrollTop || document.documentElement.scrollTop
      document.body.style.cssText += 'position:fixed;top:-' + scrollTop + 'px;'
    },
    looseBody () {
      const body = document.body
      body.style.position = 'static'
      const top = body.style.top
      document.body.scrollTop = document.documentElement.scrollTop = -parseInt(top)
      body.style.top = ''
    },
    clickLogo () {
      this.activeRoute = 'mhome'
      this.$router.push({ name: 'mhome' })
    },
    toggleMenu (route = {}, index) {
      this.showMenu = !this.showMenu
      route.activeIndex = index
      if (this.showMenu) {
        this.fixedBody()
      } else {
        this.looseBody()
      }
    }
  }
}
</script>
<style lang="less">
.mb-main{
  position: relative;
  width: 100%;
  height: 100%;
  background: white;
  display: flex;
  flex-direction: column;
  overflow-y: hidden;
  header{
    margin-top: 10px;
    flex: 0 0 45px;
    height: 45px;
    padding: 0 18px 14px;
    display: flex;
    justify-content: space-between;
    // align-items: center;
    .logo{
      width: 93px;
      height: 29px;
    }
    .aside{
      width: 50px;
      height: 30px;
      &.menu{
        background-image: url("../../assets/mobile/menu.png");
        background-position: 25px 8px;
        background-size: 19px 15px;
        background-repeat: no-repeat;
      }
      &.close{
        background-image: url("../../assets/mobile/close.png");
        background-position: 25px 8px;
        background-size: 14px 15px;
        background-repeat: no-repeat;
      }
    }
  }
  .nav{
    position: absolute;
    top: 45px;
    right: 0;
    width: 50%;
    height: 100%;
    background: white;
    z-index: 9999;
    padding: 0 18px;
    font-size: 16px;
    color: #081530;
    text-align: left;
    overflow-y: scroll;
    scroll-behavior: smooth;
    >ul{
      padding: 0 0 30px;
      margin: 0;
      li{
        list-style-type:none;
        line-height: 48px;
        border-bottom: 1px #E5E5E5 solid;
        &:last-child{
          border-bottom: none;
        }
        &.active{
          color: #13E4E8;
        }
        .sub-menu{
          padding-left: 0;
          li{
            border-bottom: none;
          }
          a{
            font-size: 14px;
            color: #081530;
            &.sub-active{
              color: #13E4E8;
            }
          }
        }
      }
    }
  }
  .mb-main-container{
    position: relative;
    width: 100%;
    flex: auto;
    overflow-y: scroll;
    scroll-behavior: smooth;
    // background: red;
    footer{
      // height: 141px;
      padding: 15px 16.5px;
      background: #2B2D33;
      color: #fff;
      text-align: left;
      p{
        opacity: .6;
        font-size: 11px;
        line-height: 15px;
        margin: 0;
      }
      .one{
        >p:first-child{
          opacity: 1;
          font-size: 14px;
          line-height: 20px;
          margin-bottom: 4px;
        }
      }
      .two{
        margin: 15px 0 10px 0;
      }
    }
  }
}
</style>
